export const htmlContent = `
<style>
    /* Estilos básicos para o conteúdo injetado */
    .regras-container {
        font-family: Arial, sans-serif;
        line-height: 1.6;
        color: #333; /* Cor de texto principal */
        padding: 5px; /* Pequeno padding para afastar das bordas */
    }
    .regras-container h3 {
        color: #1a1a1a;
        font-size: 16px; /* Ajuste para parecer cabeçalho de seção */
        font-weight: bold;
        margin-top: 16px;
        margin-bottom: 10px;
    }
    .regras-container p {
        font-size: 14px;
        margin-bottom: 10px;
    }
    .regras-container ul.ordenada {
        list-style: decimal;
        padding-left: 20px;
        margin-top: 5px;
        font-size: 14px;
    }
    /* Estilo de destaque para as regras importantes */
    .regras-importantes {
        margin-top: 20px;        
        padding-left: 5px;
        padding-top: 5px;
        padding-bottom: 5px;
       
    }
    .regras-importantes h3 {
        font-size: 16px; 
        margin-top: 5px; 
        margin-bottom: 10px;
        color: #1a1a1a;
    }
    .regras-importantes ul {
        list-style: disc;
        margin-left: 20px;
        font-size: 14px;
    }
    /* Estilos para a Tabela */
    .regras-container table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 15px;
    }
    .regras-container th, .regras-container td {        
        padding: 2px;
        text-align: left;
        font-size: 14px;
    }
    .regras-container th {
        background-color: #f2f2f2;
        font-weight: bold;
    }
</style>

<div class="regras-container">

    <h3>Regras para Importação da Planilha</h3>
    <p>A planilha deve seguir exatamente a ordem das colunas abaixo:</p>
    
    <ul class="ordenada">
        <li>Código</li>
        <li>Descrição</li>
        <li>NCM</li>
        <li>EAN/GTIN</li>
        <li>Origem da Mercadoria (informar apenas o código numérico de 0 a 8)</li>
    </ul>
    
    <div class="regras-importantes">
        <h3>Regras Importantes:</h3>
        <ul>
            <li>Se <strong>NCM</strong> e <strong>EAN/GTIN</strong> estiverem preenchidos para o mesmo produto, o sistema priorizará o <strong>EAN/GTIN</strong> para realizar a busca das alíquotas.</li>
            <li>Não é obrigatório informar ambos os códigos.</li>
            <li>Você pode preencher apenas o <strong>NCM</strong> OU apenas o <strong>EAN/GTIN</strong>.</li>
        </ul>
    </div>

    <h3>Tabela de Origem da Mercadoria (0 a 8)</h3>
    <table>
        <thead>
            <tr>
                <th>Código</th>
                <th>Descrição da Origem</th>
            </tr>
        </thead>
        <tbody>
            <tr><td>0</td><td>Nacional, exceto as indicadas nos códigos 3, 4, 5 e 8;</td></tr>
            <tr><td>1</td><td>Estrangeira – Importação direta, exceto a indicada no código 6;</td></tr>
            <tr><td>2</td><td>Estrangeira – Adquirida no mercado interno, exceto a indicada no código 7;</td></tr>
            <tr><td>3</td><td>Nacional, mercadoria ou bem com Conteúdo de Importação superior a 40% e inferior ou igual a 70%;</td></tr>
            <tr><td>4</td><td>Nacional, cuja produção tenha sido feita em conformidade com os processos produtivos básicos de que tratam o Decreto-Lei n° 288/67, e as Leis n° 8.248/91, 8.387/91, 10.176/01 e 11.484/07;</td></tr>
            <tr><td>5</td><td>Nacional, mercadoria ou bem com Conteúdo de Importação inferior ou igual a 40%;</td></tr>
            <tr><td>6</td><td>Estrangeira – Importação direta, sem similar nacional, constante em lista de Resolução CAMEX e gás natural;</td></tr>
            <tr><td>7</td><td>Estrangeira – Adquirida no mercado interno, sem similar nacional, constante em lista de Resolução CAMEX e gás natural;</td></tr>
            <tr><td>8</td><td>Nacional, mercadoria ou bem com Conteúdo de Importação superior a 70%.</td></tr>
        </tbody>
    </table>

</div>
`;

